import HeaderComponent from "../Components/HeaderComponent";
import FooterTopComponent from "../Components/FooterTopComponent";
import FooterBottomComponent from "../Components/FooterBottomComponent";
import React from "react";
import config from "../config";

export default function PrivacyPage() {
    return (
        <main>
            <HeaderComponent/>
            <h1>{config.pages.privacy.title}</h1>

            <FooterTopComponent />
            <FooterBottomComponent />
        </main>
    );
}
